<template>
  <div class="rb-comments">
    <comment
      v-for="comment in comments"
      :key="comment.id"
      :user="user"
      :comment="comment"
      @comment-updated="updateComment($event)"
      @comment-deleted="deleteComment($event)"
    ></comment>
    <div class="comment-input">
      <vue-tribute :options="tributeOptions">
        <input
          contenteditable="true"
          data-ph="Add a comment"
          @keyup="checkMention"
          placeholder="Add a comment"
        />
      </vue-tribute>
    </div>
  </div>
</template>

<script>
import comment from "./CommentItem";
import VueTribute from "vue-tribute";

export default {
  created() {
    this.fetchComments();
  },
  components: {
    comment,
    VueTribute
  },
  props: {
    user: {
      required: true,
      type: Object
    },
    users: {
      required: true,
      type: Array
    },
    userImage: {
      type: String
    },
    widget: {
      required: true,
      type: Number
    }
  },
  methods: {
    checkMention(event) {
      if (event.key == "Enter" && this.blockSubmit == true) {
        this.blockSubmit = false;
      } else {
        if (event.key == "Enter") {
          this.data.content = event.target.value;
          const t = this;
          event.target.value = "";
          axios.post("/comments", t.data).then(({ data }) => {
            t.comments.push(data);
            t.stopEditing();
            $("#" + t.widget + "-comment-counter").html(
              parseInt($("#" + t.widget + "-comment-counter").html()) + 1
            );
          });
        } else {
          if ($(".tribute-container").is(":visible")) {
            this.blockSubmit = true;
          } else {
            this.blockSubmit = false;
          }
        }
      }
    },
    updateComment($event) {
      const t = this;

      axios.put(`/comments/${$event.id}`, $event).then(({ data }) => {
        t.comments[t.commentIndex($event.id)].content = data.content;
      });
    },
    deleteComment($event) {
      const t = this;
      axios.delete(`/comments/${$event.id}`, $event).then(() => {
        t.comments.splice(t.commentIndex($event.id), 1);
        $("#" + t.widget + "-comment-counter").html(
          parseInt($("#" + t.widget + "-comment-counter").html()) - 1
        );
      });
    },
    commentIndex(commentId) {
      return this.comments.findIndex(element => {
        return element.id === commentId;
      });
    },
    fetchComments() {
      const t = this;
      axios.get("/comments/" + this.widget).then(({ data }) => {
        t.comments = data;
      });
    },

    startEditing() {
      this.state = "editing";
    },
    stopEditing() {
      this.state = "default";
      this.data.content = "";
    },
    saveComment() {
      if (this.blockSubmit) {
      } else {
        const t = this;
        axios.post("/comments", t.data).then(({ data }) => {
          t.comments.push(data);
          t.stopEditing();
          $("#" + t.widget + "-comment-counter").html(
            parseInt($("#" + t.widget + "-comment-counter").html()) + 1
          );
        });
      }
    }
  },
  data: function() {
    return {
      blockSubmit: false,
      state: "default",
      tributeOptions: {
        trigger: "@",
        spaceSelectsMatch: true,
        values: this.users
      },
      data: {
        content: "",
        widget: this.widget
      },
      comments: []
    };
  }
};
</script>


// WEBPACK FOOTER //
// resources/js/components/admin/commentsManager.vue